import { defineSlotRecipe } from '@chakra-ui/react';

export const selectRecipe = defineSlotRecipe({
	slots: ['root', 'indicator', 'trigger', 'valueText', 'content'],
	base: {
		root: {
			bg: 'white',
		},
		indicator: {
			color: 'brand.primary.500',
		},
	},
});
